const PRODUCTION_API = "https://airporttaxitransfersvarna.com";
const LOCAL_API = "http://localhost:8888";

const isLocalHost = (hostname) =>
	hostname === "localhost" || hostname === "127.0.0.1";

export const getApiBaseUrl = () => {
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL.replace(/\/$/, "");
	}

	if (typeof window !== "undefined") {
		const { hostname, port } = window.location;

		if (isLocalHost(hostname)) {
			// CRA dev server proxies /send-email to the live API.
			if (process.env.NODE_ENV === "development" && port === "3000") {
				return "";
			}

			// Local preview builds talk to the Node API directly.
			return LOCAL_API;
		}

		return "";
	}

	return process.env.NODE_ENV === "development" ? "" : PRODUCTION_API;
};

export const SEND_EMAIL_URL = `${getApiBaseUrl()}/send-email`;
